module.exports = __webpack_public_path__ + "static/media/FIPE_3_LIVELLO1.69276249.jpg";